export const cornerTypeModule={
    "CORNER_LEFT": "Угол слева",
    "CORNER_RIGHT": "Угол справа",
    "STRAIGHT": "Прямая",
}

